import React from 'react';

import classNames from 'classnames';

import './QuestionRadioButton.scss';

type QuestionRadioButtonProps = {
  selected: boolean;
};

export const QuestionRadioButton: React.FC<QuestionRadioButtonProps> = ({ selected }) => {
  return <div className={classNames('question-radio-button', { 'question-radio-button--selected': selected })} />;
};
